// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronRight: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.482 12.029c.002.397-.154.778-.433 1.06l-5.972 5.972a1.5 1.5 0 0 1-2.12-2.12l4.941-4.912-4.747-4.926a1.492 1.492 0 1 1 2.15-2.06l5.763 5.972c.263.272.412.635.418 1.014z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const ChevronRightOffset: IconOffset = {
    vertical: 18,
    horizontal: 31,
};

export default React.memo(ChevronRight);
